export const DOWNLOAD_ORDERED_URI = 'cart/downloadOrdered';
